import Base, { env, goLocal } from './base';

const BACKOFFICE_BASE_URL =
  env === 'development' && goLocal
    ? process.env.REACT_APP_BACKOFFICE_BASE_URL || 'http://localhost:64102'
    : process.env.REACT_APP_BACKOFFICE_BASE_URL;

const axiosOptions = {
  baseURL: BACKOFFICE_BASE_URL,
};
class Backoffice extends Base {
  constructor() {
    super('backoffice', BACKOFFICE_BASE_URL, axiosOptions);
  }

  getOperations(opts) {
    const options = {
      url: '/operations',
      ...opts,
    };
    return this.get(options);
  }

  bulkAdd(payload, valueAsync) {
    const options = {
      url: '/upload/bulk',
      data: payload,
      qs: {
        async: valueAsync
      },
      timeout: 2000000
    };
    return this.post(options);
  }

  getOneById(id) {
    const options = {
      uri: `/operations/${id}`,
    };
    return this.get(options);
  }

  addOne(payload) {
    const options = { uri: '/operations', data: payload };
    return this.post(options);
  }

  updateOne(payload) {
    const options = { uri: `/operations/${payload.id}`, data: payload };
    return this.put(options);
  }

  // creates TXT with document|link
  generateLinks(filters, valueAsync) {
    const options = {
      uri: '/download/links',
      data: { filters },
      qs: {
        async: valueAsync
      }
    };
    return this.post(options);
  }

  // creates file with all operation data
  exportFilteredOperations(filters, valueAsync) {
    const options = {
      uri: 'download/export_excel',
      data: { filters },
      qs: {
        async: valueAsync
      }
    };
    return this.post(options);
  }

  //Download success operation PDF

  downloadSuccess(id) {
    const options = {
      uri: 'download/export_operations_success',
      data: id,
      responseType: 'blob',
    };
    return this.post(options);
  }

  // creates TXT with special data only for successful operations
  exportSuccessfulOperations(filters) {
    const options = {
      uri: '/download/export_operations',
      data: { filters },
      responseType: 'blob',
    };
    return this.post(options);
  }

  getPresignedUrl(fields) {
    const options = {
      uri: '/files/getPresignedUrl',
      qs: fields
    };
    return this.get(options);
  }

  updatePresignedFile(id, data) {
    const options = {
      uri: `/files/updatePresignedFile/${id}`,
      data: {
        signature: data['X-Amz-Signature']
      }
    };
    return this.put(options);
  }

  uploadFile(url, data) {
    const options = {
      uri: url,
      data,
      timeout: 2000000
    };
    
    this.instance.defaults.headers={}
    
    return this.post(options);
  }
}

export default new Backoffice();
